import { render, staticRenderFns } from "./CountrySearch.vue?vue&type=template&id=1520f3bc"
import script from "./CountrySearch.vue?vue&type=script&lang=js"
export * from "./CountrySearch.vue?vue&type=script&lang=js"
import style0 from "./CountrySearch.vue?vue&type=style&index=0&id=1520f3bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports